import { useEffect, useState } from 'react';

export const detectInstalledAppView = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  if (params.get('app') === '1' || params.get('native') === '1') {
    return true;
  }

  const standaloneDisplay =
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches;
  const navigatorStandalone = Boolean((navigator as Navigator & { standalone?: boolean }).standalone);
  const userAgent = navigator.userAgent || '';
  const isIOSWebView = /iP(hone|od|ad)/.test(userAgent) && /AppleWebKit/.test(userAgent) && !/Safari/.test(userAgent);
  const isAndroidWebView = /\bwv\b/.test(userAgent) || /Version\/[\d.]+.*Chrome/.test(userAgent);

  return standaloneDisplay || navigatorStandalone || isIOSWebView || isAndroidWebView;
};

const useInstalledAppView = () => {
  const [isInstalledAppView, setIsInstalledAppView] = useState(() => detectInstalledAppView());

  useEffect(() => {
    const syncInstalledAppView = () => setIsInstalledAppView(detectInstalledAppView());
    const standaloneQuery = window.matchMedia('(display-mode: standalone)');
    const fullscreenQuery = window.matchMedia('(display-mode: fullscreen)');

    syncInstalledAppView();
    standaloneQuery.addEventListener?.('change', syncInstalledAppView);
    fullscreenQuery.addEventListener?.('change', syncInstalledAppView);
    window.addEventListener('pageshow', syncInstalledAppView);

    return () => {
      standaloneQuery.removeEventListener?.('change', syncInstalledAppView);
      fullscreenQuery.removeEventListener?.('change', syncInstalledAppView);
      window.removeEventListener('pageshow', syncInstalledAppView);
    };
  }, []);

  return isInstalledAppView;
};

export default useInstalledAppView;
